/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * A service\'s health.
 * @export
 * @interface Health
 */
export interface Health {
    /**
     * The service ID.
     * @type {string}
     * @memberof Health
     */
    'serviceId': string;
    /**
     * The health status.
     * @type {string}
     * @memberof Health
     */
    'status': HealthStatusEnum;
    /**
     * The service uptime for the past 30 days.
     * @type {number}
     * @memberof Health
     */
    'uptimePercentage': number;
}

export const HealthStatusEnum = {
    STATUS_UNSPECIFIED: 'STATUS_UNSPECIFIED',
    HEALTHY: 'HEALTHY',
    DEGRADED: 'DEGRADED',
    DOWN: 'DOWN'
} as const;

export type HealthStatusEnum = typeof HealthStatusEnum[keyof typeof HealthStatusEnum];


